import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable, Injector } from '@angular/core';

import { Observable, filter, forkJoin, map, of } from 'rxjs';

import { environment } from 'src/environments/environment';

import Swal from 'sweetalert2';

import * as CryptoJS from 'crypto-js';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({

  providedIn: 'root',

})

export class AccountService {

  encryptionKey = environment.encryptionKey;

  list_StoredAds: any = [];

  list_StoredCity: any = [];

  list_StoredCity_By_Image: any = [];

  list_StoredNews: any = [];

  list_StoredCategory: any = [];

  list_StoredCurrency: string = '';

  list_StoredCondition: any = [];

  list_Stored_CityList4Support: any = [];

  list_Stored_groups: any = [];

  list_Stored_groupsSamsari: any = [];

  list_Stored_groupsEmploy: any = [];

  tiType_Stored: number;

  bDateJalali_Stored: boolean | null = null;

  private currentUrl: string = '';

  constructor(private http: HttpClient, private injector: Injector) {

    const router = this.injector.get(Router);

    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {

      this.currentUrl = event.url;

      this.tracker_Visits();

      // this.getBasic_Info();

    });


  }

  async tracker_Visits() {

    if (!window.origin.includes('localhost')) {

      const UserAgent = navigator.userAgent;

      let strDevice: string = 'Unknown Device';

      if (/iPad/.test(UserAgent)) {
        strDevice = 'iPad';
      }

      else if (/iPhone/.test(UserAgent)) {
        strDevice = 'iPhone';
      }

      else if (/Android/.test(UserAgent)) {
        strDevice = 'Android';
      }

      else if (/Windows/.test(UserAgent)) {
        strDevice = 'Windows';
      }

      const getOS = (): string => {
        // Using a simplified method to get the OS name
        if (/Windows NT/.test(UserAgent)) return 'Windows';
        if (/Macintosh/.test(UserAgent)) return 'Mac OS';
        if (/Android/.test(UserAgent)) return 'Android';
        if (/iOS/.test(UserAgent)) return 'iOS';
        return 'Unknown OS';
      };

      const strOS = getOS();

      const model = {
        iTaxiLon_User: this.getLocalStorage().Id || 0,   // User id
        strNavigator: navigator.userAgent,   // Browser name and version
        strLanguage: navigator.language,     // Language
        strDevice: strDevice,                // Device name
        strOS: strOS,                        // Operating System
        strEffectiveType: 'unknown', // Network type
        strURL: window.origin + this.currentUrl, // Full page URL
        strReferrer: document.referrer,      // Referring page URL
      };

      try {

        const response = await fetch(environment.taxiUrl + `TrackPageVisit`, {

          method: 'POST',

          headers: { 'Content-Type': 'application/json' },

          body: JSON.stringify(model),

        });

        // console.log('Server Response:', await response.json());

      }

      catch (error) {

        console.error('Error:', error);

      }

    }

  }

  getLocalStorage() {

    if (localStorage.getItem('db30a17f18d1a8a3l0ifr4z8ab0b02')) {

      var item = JSON.parse(this.decrypt(localStorage.getItem('db30a17f18d1a8a3l0ifr4z8ab0b02')!))

      return item;

    }

    else return {}

  }

  toastSwal(type, string, timer?) {
    if (timer === undefined) {
      timer = 3000;
    }
    Swal.fire({
      position: 'bottom-end',
      icon: type,
      toast: true,
      background:
        type == 'success'
          ? '#008631'
          : type == 'error'
            ? '#DF1C24'
            : type == 'warning'
              ? '#54c3e6'
              : '#3fc3ee',
      color: '#fff',
      timerProgressBar: true,
      title: string,
      customClass: {
        title: 'toaster-lineSpacing',
      },
      showConfirmButton: false,
      timer: timer,
    });
  }

  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.encryptionKey).toString();
  }

  decrypt(value: string) {
    return value != null
      ? CryptoJS.AES.decrypt(value, this.encryptionKey).toString(
        CryptoJS.enc.Utf8
      )
      : '';
  }

  //  taxilon api from here//////////////////////////////////////////

  taxiLogin(model: any) {
    return this.http.post(environment.taxiUrl + 'TaxiLon_User_CheckUser', model);
  }

  getNewSession(model: any) {
    return this.http.post(environment.taxiUrl + 'TaxiLon_User_ReNewSession', model);
  }

  taxiCheckOTP(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_User_CheckOTP`, model);
  }

  taxiSubmit(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_User_InitialRegistration`, model);
  }

  TaxiLon_City_List() {
    return this.http.post(environment.taxiUrl + `TaxiLon_City_List`, {});
  }

  TaxiLon_MobileGroup_List() {
    return this.http.post(environment.taxiUrl + `TaxiLon_MobileGroup_List`, {});
  }

  TaxiLon_User_TravelCostEstimate(model) {
    return this.http.post(environment.taxiUrl + `Rahyar24_User_TravelCostEstimate`, model);
  }

  EmdadRo_User_Save(model) {
    return this.http.post(environment.taxiUrl + `EmdadRo_User_Save`, model);
  }

  EmdadRo_Partner_Save(model) {
    return this.http.post(environment.taxiUrl + `EmdadRan_Partner_Save`, model);
  }

  TaxiLon_Trip_Passenger_Save(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Passenger_Save`, model);
  }

  taxiLon_PayInvoice(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Passenger_PayInvoice`, { ...model, tiAppType: 2 });
  }
  emdadran_PayInvoice(model) {
    return this.http.post(environment.taxiUrl + `EmdadRan_ReturnIntermediateLink`, model);
  }
  TaxiLon_News(model) {
    return this.http.post(environment.taxiUrl + `TaxilLon_News_List?iPage=${model.iPage}`, {});
  }
  TaxiLon_AtLeastTime() {
    return this.http.post(environment.taxiUrl + `TaxiLon_AtLeastTime`, {});
  }
  TaxiLon_News_Info(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_News_Info?iNews=${model}`, {});
  }
  TaxiLon_Trip_Passenger_List(model) {
    return this.http.post(environment.taxiUrl + `EmdadRo_Passenger_List`, model);
  }
  Taxilon_AdsType(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_AdvertisementType_List`, model);
  }
  EmdadRo_Images_Req(model) {
    return this.http.post(environment.taxiUrl + `EmdadRo_Images_List`, model);
  }
  EmdadRo_ValidityCheckOut(model) {
    return this.http.post(environment.taxiUrl + `EmdadRo_CraneSpecifications`, model);
  }
  TaxiLon_Trip_Passenger_Cancel(model) {
    return this.http.post(environment.taxiUrl + `EmdadRo_Passenger_Cancel`, model);
  }
  TaxiLon_Trip_Passenger_SetPoints(model) {
    return this.http.post(environment.taxiUrl + `EmdadRo_Passenger_SetPoints`, model);
  }
  TaxiLon_Tiket_List(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Tiket_List`, model);
  }
  TaxiLon_Tiket_Subjects_List(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Tiket_Subjects_List`, model);
  }
  TaxiLon_Tiket_Save(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Tiket_Save`, model);
  }
  TaxiLon_Tiket_Delete(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Tiket_Delete`, model);
  }
  TaxiLon_User_Update(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_User_Update`, model);
  }
  emdadRo_EvidenceDriver(model) {
    return this.http.post(environment.taxiUrl + `EmdadRo_EvidenceDriver_List4Passenger`, model);
  }
  Captcha_Get() {
    return this.http.post(environment.taxiUrl + `Captcha_Get`, {});
  }

  getTaxiLon_Drivers() {

    if (!window.origin.includes('localhost')) {

      return this.http.post(environment.taxiUrl + `EmdadRo_Drivers`, {});
    }

    else {

      return this.http.post(environment.taxiUrl + `TaxiLon_Drivers`, {});

    }

  }

  TaxiLon_EvidenceDriver_Info4Passenger(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_EvidenceDriver_Info4Passenger`, model);
  }

  taxiLon_CheckPoints(model) {
    return this.http.post(environment.taxiUrl + `EmdadRo_User_CheckTripHasNoPoints`, model);
  }

  taxiLon_SetPoints(model) {
    return this.http.post(environment.taxiUrl + `EmdadRo_Passenger_SetPoints`, model);
  }

  TaxiLon_Opinions() {

    return this.http.post(environment.taxiUrl + `EmdadRo_PassengerOpinions`, {});

  }

  partner_Register(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Partner_Register`, model);
  }

  partner_Login(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Partner_Login`, model);
  }

  partner_OTP(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Partner_CheckOTP`, model);
  }

  partner_Reset_Password(strMobile) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Partner_ForgetPassword?strMobile=${strMobile}`, {});
  }

  checkPayment(model) {
    return this.http.post(environment.taxiUrl + `EmdadRan_Passenger_CheckPayment`, model);
  }

  TaxiLon_City_Search(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_City_4PublicSearch`, model);
  }

  TaxiLon_MobileType_Search(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_MobileType_4PublicSearch`, model);
  }

  TaxiLon_GPSType_Search(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_GPSType_4PublicSearch`, model);
  }

  Taxilon_Advertisement(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_Advertisement_Public_List`, model);
  }

  Taxilon_Ads_Info(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_Advertisement_Public_Info`, model);
  }

  TaxiLon_Ads_Gallery(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_Advertisement_Gallery_List?iTaxilon_Advertisement=${model.iTaxilon_Advertisement}`, {});
  }

  Taxilon_DynamicLink(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_Advertisement_DynamicLink?strSiteUrl=${model.strSiteUrl}&iTaxilon_Advertisement=${model.iTaxilon_Advertisement}`, {});
  }

  get_AdsDetail_VS_Gallery(model): Observable<any> {

    return forkJoin([

      this.Taxilon_Ads_Info(model),

      this.TaxiLon_Ads_Gallery(model),

      this.Taxilon_DynamicLink(model)

    ]).pipe(map(([adsInfo, gallery, links]) => ({ adsInfo, gallery, links })));

    // ]).pipe(map(([adsInfo, gallery]) => ({ adsInfo, gallery })));

  }

  Taxilon_Ads_New() {
    return this.http.post(environment.taxiUrl + `Taxilon_Advertisement_Public_List_New`, {});
  }

  Taxilon_Ads_Number(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_GetUserInfo`, model);
  }

  EmdadRo_Route(model) {
    return this.http.post(environment.taxiUrl + `EmdadRo_Passenger_Route`, model);
  }

  Taxilon_Ads_Note(model) {

    fetch(environment.taxiUrl + `Taxilon_Advertisement_RecentVisit_UpdateComment`, {

      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify(model),

    });

  }

  Taxilon_GetHelp() {
    return this.http.post(environment.taxiUrl + `EmdadRo_GetHelp?ID=200`, {});
  }

  getMobileType() {
    return this.http.post(environment.taxiUrl + `GetMobileType`, {});
  }

  getMobileGroup() {
    return this.http.post(environment.taxiUrl + `GetMobileGroup`, {});
  }

  getReason4Request() {
    return this.http.post(environment.taxiUrl + `Reason4Request`, {});
  }

  getReliefType() {
    return this.http.post(environment.taxiUrl + `ReliefRequestType`, {});
  }

  Educational_List() {
    return this.http.post(environment.taxiUrl + `EducationalContent_List`, {});
  }

  Educational_Info(iEducationalContent) {
    return this.http.post(environment.taxiUrl + `EducationalContent_Info?iEducationalContent=${iEducationalContent}`, {});
  }

  Dyar_PopupADV_Get(model) {
    return this.http.post(environment.taxiUrl + `Dyar_PopupADV_Get`, model);
  }

  Resume_Info4UserFromMap(model) {
    return this.http.post(environment.taxiUrl + `Resume_Info4UserFromMap`, model);
  }

  Dyar_BusinessGroupSearch() {
    return this.http.post(
      environment.taxiUrl + `Resume_Category_List4ResumeHaveInfo`,
      {}
    );
  }

  Dyar_BusinessSubgroup(iResume_Category) {
    return this.http.post(
      environment.taxiUrl +
      `Resume_SubCategory_List4Resume?iResume_Category=${iResume_Category}`,
      {}
    );
  }

  Dyar_BusinessSubgroupSearch(iResume_Category) {
    return this.http.post(
      environment.taxiUrl +
      `Resume_SubCategory_List4ResumeHaveInfo?iResume_Category=${iResume_Category}`,
      {}
    );
  }

  GetState() {
    return this.http.post(environment.taxiUrl + `TaxiLon_State_List`, {});
  }

  GetCity(code, model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_City_List4State?strState=${code}`, model);
  }

  resume_Gallery_List(model) {
    return this.http.post(
      environment.taxiUrl + `Resume_Gallery_List4User`,
      model
    );
  }

  resume_Info4User(model) {
    return this.http.post(environment.taxiUrl + `Resume_Info4User`, model);
  }

  resumeSimlarList(model) {
    return this.http.post(environment.taxiUrl + `Resume_Similar`, model);
  }

  Dyar_Business_DynamicLink(model) {

    return this.http.post(environment.taxiUrl + `Dyar_Business_DynamicLink?strSiteUrl=${model.strSiteUrl}&iUserManager_User=${model.iUserManager_User}`, {});

  }

  Dyar_UpdateComment(model) {
    fetch(environment.taxiUrl + `Dyar_RecentVisits_UpdateComment`, {
      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify(model),
    });
  }

}
